.button {
  padding: 3px 7px;
  font-size: var(--font-size-xs);
}

.viewStyle {
  padding: 17px 0 10px 13px;
  background-color: #e0e0e0;
}

.paragraph {
  font-size: 15px;
  line-height: 1;
  color: #333;
}

.container {
  display: flex;
  gap: 20px;
  margin-top: 3px;
}

.selectedButton {
  padding: 3px 7px;
  font-size: var(--font-size-xs);
  font-weight: bold;
  background-color: var(--color-white);
  border-radius: 12px;
}
